import { FetchError } from './FetchError';
import { FETCH_TRANSFORMER_ERROR_CODE } from 'utils';

/**
 * Token refresh errors (refresh token expired, max retries exceeded)
 *
 * @example
 * ```typescript
 * throw new TokenRefreshError('Max refresh attempts exceeded', {
 *   attempts: 3,
 *   maxAttempts: 3
 * });
 * ```
 */
export class TokenRefreshError extends FetchError {
  override readonly type = 'TokenRefreshError';

  constructor(message: string, details?: Record<string, unknown>, cause?: Error) {
    super(message, FETCH_TRANSFORMER_ERROR_CODE.TOKEN_REFRESH_ERROR, undefined, details, cause);
  }
}
